// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JP-z","carouselContainer":"KP-z"};